export const scrolearAComponente = (id) => {

    let compo = window.document.getElementById(id)
    compo.scrollIntoView({
        behavior: 'smooth', // smooth scroll
        block: 'start' // the upper border of the element will be aligned at the top of the visible part of the window of the scrollable area.
    })
}